export default {
  LOGIN: "login"
};
